export const sortMessagesByDate = messages => {
  return messages.sort((a, b) => {
    return new Date(b.createdOn + 'Z') - new Date(a.createdOn + 'Z');
  });
};
